import { render } from "./StudentPreview.vue?vue&type=template&id=e3fc5ca6&scoped=true"
import script from "./StudentPreview.vue?vue&type=script&lang=js"
export * from "./StudentPreview.vue?vue&type=script&lang=js"

import "./StudentPreview.vue?vue&type=style&index=0&id=e3fc5ca6&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fc5ca6"]])

export default __exports__